<template>
  <div
    class="h-34 m:h-36 l:h-56 rounded pl-4 m:pl-8 l:pl-6 flex justify-between overflow-hidden"
    :class="backgroundColor"
  >
    <div class="flex flex-col justify-center">
      <h4 class="text-midnight font-bold mb-1 m:mb-2 text-h4 m:text-h35" v-html="$t(`${variant}.headline`)" />
      <p class="text-sm text-dark-grey mb-0 text-sm m:text-base" v-html="$t(`${variant}.copy`)" />
    </div>
    <div class="m:pr-8 l:pr-0">
      <component :is="imageComponent" />
    </div>
  </div>
</template>

<script>
import FormatBannerBlinksImage from "@/component-library/format-banner/format-banner-blinks-image"
import FormatBannerShortcastsImage from "@/component-library/format-banner/format-banner-shortcasts-image"

export const FORMAT_BANNER_BLINKS = "blinks"
export const FORMAT_BANNER_SHORTCASTS = "shortcasts"
export const FORMAT_BANNER_VARIANTS = [FORMAT_BANNER_BLINKS, FORMAT_BANNER_SHORTCASTS]

export default {
  name: "FormatBanner",
  components: { FormatBannerBlinksImage, FormatBannerShortcastsImage },
  props: {
    variant: {
      type: String,
      default: FORMAT_BANNER_BLINKS,
      validator: (value) => {
        return FORMAT_BANNER_VARIANTS.includes(value)
      }
    }
  },
  computed: {
    backgroundColor() {
      return this.variant === FORMAT_BANNER_BLINKS ? "bg-green-7" : "bg-background-purple"
    },
    imageComponent() {
      return this.variant === FORMAT_BANNER_BLINKS ? FormatBannerBlinksImage : FormatBannerShortcastsImage
    }
  },
  i18n: {
    messages: {
      de: {
        blinks: {
          headline: "Blinks",
          copy: "Kernaussagen der besten<br />Sachbücher"
        },
        shortcasts: {
          headline: "Shortcasts",
          copy: "Beliebte Wissens-<br />Podcasts in Kurzform"
        }
      },
      en: {
        blinks: {
          headline: "Blinks",
          copy: "Understand key ideas<br />from nonfiction books"
        },
        shortcasts: {
          headline: "Shortcasts",
          copy: "Understand key ideas<br />from podcasts"
        }
      }
    }
  }
}
</script>
